<template>
  <div class="c-adder">
    <Spin size="large" fix v-if="loading"></Spin>
    <Row :gutter="12">
      <Col span="10" class="c-adder-wrapper">
        <Row :gutter="12">
          <Col span="24">
            <Input
              v-model="keyword"
              :placeholder="placeholder"
              class="c-search-input"
              icon="md-close"
              search
              enter-button
              @on-click="clear"
              @on-search="search"
              @on-enter="search"
            ></Input>
          </Col>
          <template v-if="nodata">
            <Col span="24">
              <div class="c-list-empty">
                <Icon type="ios-filing-outline" size="100" color="#efefef" />
              </div>
            </Col>
          </template>
          <template v-else>
            <Col span="24" v-if="length">
              <Table
                ref="selection"
                height="250"
                class="c-adder-table"
                :columns="columns"
                :data="data"
                @on-select-cancel="cancelSelection"
                @on-selection-change="changeSelection"
              ></Table>
            </Col>
            <Col span="24" v-if="more" class="c-page-warpper">
              <Page
                :current="page"
                :total="total"
                :page-size="size"
                class-name="c-page"
                size="small"
                show-total
                @on-change="changePage"
              ></Page>
            </Col>
          </template>
        </Row>
      </Col>
      <Col span="7" offset="1">
        <div v-if="Boolean(lenState)" class="c-select">
          <div class="c-select-head">
            <span class="c-head-title">
              已选
              <ins v-if="maxtotal">（{{ lenState }}/{{ maxtotal }}）</ins>
            </span>
            <span class="c-head-clear" @click="handleClear">清空全部</span>
          </div>
          <div class="c-select-content">
            <div v-for="(item, id) in result" :key="id" class="c-pop-tip">
              <Tag :name="item.name" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, trim } from '@/common/js/utils'
import { getAppIdName } from '@/api/baidu.model'
export default {
  name: 'adder',
  props: {
    value: {
      type: Array
    },
    account: {
      type: [Number, String]
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    result: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    lenState() {
      return isArray(this.value) && this.value.length
    },
    length() {
      return this.data && this.data.length
    },
    more() {
      return this.total > this.size
    },
    nodata() {
      return this.response && !this.length
    }
  },
  methods: {
    clear() {
      this.keyword = ''
      this.reset()
    },
    reset() {
      this.response = false
      this.loading = false
      this.page = 1
      this.total = 0
      this.data = []
    },
    handleClear() {
      this.$emit('input', [])
    },
    handleClose(event, name) {
      const data = JSON.parse(JSON.stringify(this.value))
      const index = data.findIndex((ret) => ret.name === name)
      data.splice(index, 1)
      this.$emit('input', data)
    },
    changeSelection(selection) {
      if (isArray(selection)) {
        selection.forEach((ret) => {
          const index = this.result.findIndex((met) => met.name === ret.name)
          if (index < 0 && this.result.length < this.maxtotal) {
            this.result.push(ret)
          }
        })
      }
    },
    cancelSelection(selection, row) {
      const selections = [row]
      if (isArray(selections)) {
        selections.forEach((ret) => {
          const index = this.result.findIndex((met) => met.name === ret.name)
          if (index > -1) {
            this.result.splice(index, 1)
          }
        })
      }
    },
    watchSelection(list) {
      if (!isArray(list)) return
      this.data.forEach((ret) => {
        const check = list.findIndex((met) => ret.name === met.name)
        this.$set(ret, '_checked', check > -1)
      })
    },
    search() {
      this.page = 1
      this.searchAppData()
    },
    changePage(val) {
      this.page = val
      this.searchAppData()
    },
    searchAppData() {
      this.loading = true
      this.response = false
      getAppIdName({
        ad_account_id: this.account,
        query: trim(this.keyword),
        page: this.page,
        pageSize: this.size
      }).then((data) => {
        if (typeof data !== 'symbol' && data) {
          this.loading = false
          const { pageInfo, data: dataList } = data
          if (isArray(dataList) && dataList.length) {
            this.data = dataList.map((ret) => {
              const check = this.result.findIndex((met) => met.name === ret.name)
              ret._checked = check > -1
              return ret
            })
            pageInfo && (this.total = pageInfo.total_number)
          } else {
            this.response = true
            this.data = []
            this.total = 0
          }
        }
      })
    }
  },
  watch: {
    keyword(nVal) {
      if (nVal) this.reset()
    },
    value: {
      handler(nVal) {
        if (isArray(nVal)) this.watchSelection(nVal)
      },
      deep: true
    }
  },
  data() {
    return {
      loading: null,
      response: null,
      keyword: '',
      data: [], // APP数据
      page: 1, // app类分页码
      size: 30, // APP类分页大小
      total: 0, // app数据总条数
      maxtotal: 100, // APP名称限制最大
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'APP名称',
          key: 'name'
        }
      ] // APP数据表头
    }
  }
}
</script>
<style lang="scss" scoped>
.c-adder {
  min-height: 282px;
  position: relative;
}

.c-adder-table th {
  height: 28px;
}

.c-adder-table td {
  height: 32px;
}

.c-search-input {
  .ivu-icon-md-close {
    right: 0;
    display: none;
  }

  &:hover {
    .ivu-icon-md-close {
      display: inline-block;
    }
  }
}

.c-adder-wrapper {
  min-width: 514px;
}

.c-page-warpper {
  margin-top: 15px;

  .c-page {
    min-width: 514px;
  }
}

.c-select {
  min-width: 224px;
  background-color: #fff;
  border: solid 1px #dee4f5;

  .c-select-head {
    padding: 0 12px;
    height: 34px;
    font-size: 14px;
    color: #333;
    border-bottom: solid 1px #dee4f5;
    background-color: #fafbfe;

    .c-head-title,
    .c-head-clear {
      height: 34px;
      line-height: 34px;
      vertical-align: middle;
    }

    .c-head-clear {
      color: #598fe6;
      float: right;
      cursor: pointer;
      margin-left: 12px;
    }
  }

  .c-select-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 282px;
    padding-bottom: 8px;
  }

  .c-pop-tip {
    width: 100%;
  }

  .c-tag-item {
    margin: 8px 8px 0;
    padding: 2px 6px;
    display: block;
    font-size: 14px;
    height: 28px;
    user-select: none;
  }
}

.c-list-empty {
  width: 100%;
  min-height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
